import React, { useEffect, useState } from 'react';
import { useResusContext } from '../Resus/ResusContext';
import './AirwaysRecommendedValues.css';
import { getHospitalData } from './PerHospitalResusConfig';
import { useTranslation } from 'react-i18next';

interface AirwaysForAge {
  blade: number;
  cuffedETT: number;
  ETT: number;
  lma: number;
}

interface AirwaysRecommendedValuesProps {
  showTitle?: boolean;
}

const AirwaysRecommendedValues: React.FC<AirwaysRecommendedValuesProps> = ({ showTitle = true }) => {
  const { age, weight, hospital } = useResusContext();
  const [airwaysForAge, setAirwaysForAge] = useState<AirwaysForAge>({} as AirwaysForAge);
  const { t } = useTranslation(['resus']);

  const airwaysData = getHospitalData(hospital).airways;
  const getChestTubeSize = (ageInMonths: number | null | undefined): string => {
    if (ageInMonths === null || ageInMonths === undefined) return "";
    if (ageInMonths < 3) return "8-12";
    if (ageInMonths < 36) return "12-16";
    if (ageInMonths < 144) return "16-24";
    return "20-32";
  };
 
  useEffect(() => {
    if (age !== null && age !== undefined && airwaysData.dataByAge) {
      const currData = airwaysData.dataByAge.find((data: any) => data.age === age);
      if (currData) {
        setAirwaysForAge(currData);
      }
    } else {
      setAirwaysForAge({} as AirwaysForAge);
    }
  }, [age, airwaysData]);

  return (
    <>
      {showTitle && <h5 className="airways-title">{t('airways.recommendedValues')}</h5>}
      <div className="airways-recommendations">      
        <ul className="airways-list">
          <span className="defi-data">{t('airways.laryngoscopeBlade')}: {airwaysForAge.blade}</span><br />
          <span className="defi-data">{t('airways.cuffedTube')}: {airwaysForAge.cuffedETT}</span><br />
          <span className="defi-data">{t('airways.tube')}: {airwaysForAge.ETT}</span><br />
          <span className="defi-data" style={{direction: 'ltr'}}>{airwaysForAge.lma}: {t('airways.lma')}</span><br />
          {age !== null && age !== undefined && <span className="defi-data">{t('airways.chestTube')} (Fr): {getChestTubeSize(age)}</span>}
        </ul>
      </div>
    </>
  );
};

export default AirwaysRecommendedValues;